module.exports = __webpack_public_path__ + "img/3中文.bb9949f8.png";